import React from 'react'
import {
  ButtonGroup,
  Typography,
  makeStyles, TextField, CircularProgress, Box,
} from '@material-ui/core'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'
import classnames from 'classnames'

const useStyles = makeStyles((theme) => ({
  codeGroup: {
    position: 'relative',
    alignItems: 'center',
    width: '100%',
    flexDirection: 'column',
  },
  code: {
    height: theme.spacing(8),
    width: '100%',
  },
  buttonResend: {
    height: theme.spacing(7),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    marginTop: '3vh',
    // padding: '10px',
  },
  buttonResendLableDesc: {
    color: '#acacac',
  },
  buttonResendLableTitle: {
    fontSize: theme.spacing(2),
    fontWeight: 'bold',
    color: '#9fd687',
  },
  activeResend: {
    cursor: 'pointer',
    color: '#4faf25',
  },
  timer: {
    display: 'inline-flex',
    top: theme.spacing(3.5),
    right: theme.spacing(-6.5),
    transform: 'scale(-1, 1)',
    // marginLeft: theme.spacing(1),
  },
  insideTimer: {
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    position: 'absolute',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: '50%',
    transform: 'scale(-1, 1)',
  },
  containerTimer: {
    display: 'flex',
    alignItems: 'center',
    flexFlow: 'row',
    justifyContent: 'space-between',
    width: '100%',
    marginTop: '1rem',
  },
}))

function CircularProgressWithLabel({ setFinishTime }) {
  const [progress, setProgress] = React.useState(120)
  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress((prevProgress) => {
        if (prevProgress > 1) {
          return prevProgress - 1
        }
        clearInterval(timer)
        setFinishTime(true)
        return 0
      })
    }, 1000)
    return () => {
      clearInterval(timer)
    }
  }, [])
  const classes = useStyles()
  const divided = Math.floor(progress / 60)
    .toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
  const remainder = Math.round(progress % 60)
    .toLocaleString('en-US', { minimumIntegerDigits: 2, useGrouping: false })
  return (
    <Box classes={{ root: classes.timer }}>
      <CircularProgress variant="determinate" value={progress / 1.2} thickness={4.6} />
      <Box classes={{ root: classes.insideTimer }}>
        <Typography variant="caption" component="div" color="textSecondary">
          {`${divided}:${remainder}`}
        </Typography>
      </Box>
    </Box>
  )
}
CircularProgressWithLabel.propTypes = {
  setFinishTime: PropTypes.func,
}

const InputTimer = ({
  errors,
  handleBlur,
  handleChange,
  touched,
  values,
  finishTimeState,
  handleResendCode,
}) => {
  const [reload, setReload] = React.useState(true)
  const [finishTime, setFinishTime] = finishTimeState
  const { t } = useTranslation()
  const classes = useStyles()

  return (
    <ButtonGroup color="primary" classes={{ root: classes.codeGroup }}>
      <TextField
        classes={{ root: classes.code }}
        error={Boolean(touched.code && errors.code)}
        dir="rtl"
        InputLabelProps={{ dir: 'ltr' }}
        helperText={touched.code && errors.code}
        // label={`${t('code')} ${t('six')} ${t('digit')}`}
        placeholder={`${t('code')} ${t('six')} ${t('digit')}`}
        margin="normal"
        name="code"
        onBlur={handleBlur}
        onChange={(e) => (e.target.validity.valid ? handleChange(e) : null)}
        type="text"
        value={values.code}
        variant="outlined"
        autoFocus
        fullWidth
        inputProps={{
          maxLength: 6,
          pattern: '[0-9]*',
        }}
      />

      <Box classes={{ root: classes.containerTimer }}>
        {
          reload && (
          <CircularProgressWithLabel
            setFinishTime={setFinishTime}
          />
          )
        }
        <Box
          classes={{ root: classes.buttonResend }}
        >
          <span className={classes.buttonResendLableDesc}>
            {t('code_has_not_been_sent_to_you')}
            !
          </span>
          <span
            onClick={() => {
              if (finishTime) {
                handleResendCode(() => {
                  setFinishTime(false)
                  setReload(false)
                  setReload(true)
                })
              }
            }}
            className={classnames(classes.buttonResendLableTitle,
              { [classes.activeResend]: finishTime })}
          >
            {t('send_again')}
          </span>
        </Box>
      </Box>
    </ButtonGroup>
  )
}

InputTimer.propTypes = {
  errors: PropTypes.object,
  handleBlur: PropTypes.func,
  handleChange: PropTypes.func,
  touched: PropTypes.object,
  values: PropTypes.object,
  finishTimeState: PropTypes.array,
  handleResendCode: PropTypes.func,
}
export default InputTimer
